import React from 'react'

export default function CurrentPlanTag() {
  return (
    <div style={{
        font: "normal normal medium 14px/18px IBM Plex Sans",
        backgroundColor: "#9ef08f",
        color: "#135008",
        padding: "0.34vw 0.54vw",
        borderBottomLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        position: "relative",
        width: "110px",
        top: -33,
        left: 230,
        fontWeight: 500,
        textAlign: "center"
      }}>
        Current Plan
      </div>
  )
}